import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks";
import { resetUserDetails } from "../../redux/reducers/registrationSlice";
import { resetUserState } from "../../redux/reducers/userSlice";
import { persistor } from "../../redux/store";
import { Modal, GeneralButton } from "../../components";
import logout from "../../assets/images/icons/logout.svg";
import { useTranslation } from "react-i18next";

interface LogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleConfirmGoBack = useCallback(() => {
    localStorage.clear();
    dispatch(resetUserDetails());
    dispatch(resetUserState());
    window.location.reload();
    navigate("/login", { replace: true });
    persistor.purge();
    onClose();
  }, [navigate, dispatch, onClose]);

  return (
    <Modal customStyle="!p-3 md:!p-6" isOpen={isOpen} onClose={onClose}>
      <div className="flex flex-col gap-8 text-center">
        <div className="flex h-16 items-center">
          <img src={logout} alt="logout" className="mx-auto h-10 w-10" />
        </div>
        <div className="flex flex-col gap-4">
          <h3 className="text-lg font-bold">{t("logout")}</h3>
          <p className="text-body-text">
            {t("are_you_sure_you_want_to_logout")}
          </p>
        </div>
        <div className="flex items-center justify-end gap-3">
          <GeneralButton color="lite" title={t("cancel")} onClick={onClose} />
          <GeneralButton
            color="red"
            title={t("logout")}
            onClick={handleConfirmGoBack}
          />
        </div>
      </div>
    </Modal>
  );
};

export default LogoutModal;
